/* @flow strict */

import React, { Component } from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
  StripeProvider,
  Elements
} from 'react-stripe-elements';
import './styles.scss';

const createOptions = (): {} => {
  return {
    classes: {
      base: 'SimpleInput stripeFields'
    },
    style: {
      base: {
        fontSize: '14px',
        backgroundColor: '#f3f4f8',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#c23d4b'
      }
    }
  };
};

type SplitFieldsFormPropsType = {
  stripe: {
    createToken: () => void
  },
  onHandleSubmit: ({}) => void
};

class _SplitFieldsForm extends Component<SplitFieldsFormPropsType> {
  props: SplitFieldsFormPropsType;

  state = {
    errorMessage: ''
  };

  handleChange = ({ error }: any) => {
    if (error) {
      this.setState({ errorMessage: error.message });
    }
  };

  handleSubmit = (evt: any) => {
    evt.preventDefault();

    if (this.props.stripe) {
      this.props.stripe.createToken()
        .then((result: {}) => {
          this.props.onHandleSubmit(result);
        });
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };

  render(): React.Element<'form'> {
    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className="split-form">
          <label htmlFor='number'>
            <CardNumberElement
              {...createOptions()}
              onChange={this.handleChange}
            />
          </label>
        </div>
        <div className="split-form split-form__row">
          <label htmlFor='exp'>
            <CardExpiryElement
              {...createOptions()}
              onChange={this.handleChange}
            />
          </label>
          <label htmlFor='cvc'>
            <CardCVCElement {...createOptions()} onChange={this.handleChange} />
          </label>

        </div>
        <div className="error" role="alert">
          {this.state.errorMessage}
        </div>
        <button id='stripePay' style={{ display: 'none' }}>Pay</button>
      </form>
    );
  }
}

const SplitFieldsForm = injectStripe(_SplitFieldsForm);

type StripeCardPropsType = {
  stripePublicKey: string,
  onHandleSubmit: ({}) => void
};

const StripeCard = (props: StripeCardPropsType): React.Element<'div'> => {
  return (
    <StripeProvider
      apiKey={props.stripePublicKey}
    >
      <Elements>
        <SplitFieldsForm
          onHandleSubmit={(data) => {
            props.onHandleSubmit(data);
          }}
        />
      </Elements>
    </StripeProvider>
  );
};

export default StripeCard;
